// extracted by mini-css-extract-plugin
module.exports = {"page":"page__6o+at"};